import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Service Worker — caches the app shell so a tab refresh works offline.
// We register only in production builds to avoid HMR conflicts during dev.
if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
        navigator.serviceWorker
            .register("/service-worker.js", { scope: "/" })
            .then((registration) => {
                // Listen for new SW activation → reload to pick up fresh code.
                // Without this, a redeploy leaves users on the OLD bundle even
                // though a newer one is downloaded in background — which can
                // cause confusing "my login no longer works" bugs.
                let reloading = false;
                navigator.serviceWorker.addEventListener("controllerchange", () => {
                    if (reloading) return;
                    reloading = true;
                    window.location.reload();
                });
                // Check every 60s if a new SW is waiting
                setInterval(() => {
                    registration.update().catch(() => { });
                }, 60_000);
            })
            .catch(() => { /* swallow — SW is a progressive enhancement */ });
        // When SW posts "SW_ACTIVATED", we already get controllerchange above.
    });
}
